import PropTypes from 'prop-types';
import React from 'react';
import { AppBar, Grid } from '@material-ui/core';
import LocaleSelect from './LocaleSelect';
import Logo from './Logo';
import Content from './Content';

const MainBar = ({ email, location }) => (
  <AppBar color="default" position="static">
    <Grid container direction="row" alignItems="flex-start" justifyContent="space-between">
      <Grid item lg={6} md={6} sm={12}>
        <Logo />
      </Grid>
      <Grid item container direction="column" justifyContent="flex-start" alignItems="flex-end" spacing={3} lg={6} md={6} sm={12}>
        <Grid item>
          <LocaleSelect location={location} />
        </Grid>
        <Grid item>
          <Content email={email} />
        </Grid>
      </Grid>
    </Grid>
  </AppBar>
);

MainBar.propTypes = {
  email: PropTypes.string.isRequired,
  location: PropTypes.object.isRequired,
};

export default MainBar;
